import { NavAvatar } from 'header'

const MapProfile = () => {
  return <NavAvatar />
}

export { MapProfile }
